import React from 'react';
export function Proof() {
  return <section id="proof" aria-labelledby="proof-title" className="border-b border-white/5 bg-ink-800" data-id="element-165" data-mp="37tzfvsq6uo6j">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-166" data-mp="7snzou7q0gwm">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-167" data-mp="lpbbg34c1bml">
          Proof
        </p>
        <h2 id="proof-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-168" data-mp="gowzwb3ivjjt">
          Same problem. Different industry. Measured.
        </h2>

        <figure className="mt-12 rounded-xl border border-white/10 bg-ink-700 p-7 sm:p-10" data-id="element-169" data-mp="2rqmkw1kid1z">
          <figcaption className="text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-170" data-mp="3u660ofs7ixi7">
            Home services client, same response-time system:
          </figcaption>
          <div className="mt-8 grid gap-8 sm:grid-cols-2 sm:gap-10" data-id="element-171" data-mp="31h8manr49kuq">
            <div className="border-t border-white/10 pt-6" data-id="element-172" data-mp="31gyucumih3me">
              <p className="font-display text-3xl font-bold leading-tight tracking-tight text-brand sm:text-4xl" data-id="element-173" data-mp="28oqwd3ddr6yg">
                4+ hours to under 10 minutes
              </p>
              <p className="mt-3 text-sm text-white/60" data-id="element-174" data-mp="2ie0qspvp51pq">Average lead response time</p>
            </div>
            <div className="border-t border-white/10 pt-6" data-id="element-175" data-mp="2mf45h920crpd">
              <p className="font-display text-3xl font-bold leading-tight tracking-tight text-brand sm:text-4xl" data-id="element-176" data-mp="2mekqa03qshf1">
                Roughly 39%
              </p>
              <p className="mt-3 text-sm text-white/60" data-id="element-177" data-mp="1up7qkh81k7pb">
                Close rate on booked appointments
              </p>
            </div>
          </div>
        </figure>

        <p className="mt-10 max-w-3xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-178" data-mp="23omhtiw18mav">
          Real estate is the harsher version of the same race. The lead is more expensive
          and the buyer signs with whoever answers first. That is why we built the real
          estate version.
        </p>
      </div>
    </section>;
}